module.exports = __webpack_public_path__ + "media/images/banks/vn-agribank-32b2ffc82b8e3ba77307db2cc0ac29a8.png";